import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./InfrastructureFacilities.css";

import GatedCommunityProject from "../../assets/GatedCommunityProject.svg";
import Vastu from "../../assets/Vastu.svg";
import WaterTapConnection from "../../assets/waterTap.svg";
import FeetCCRoad from "../../assets/FeetCCRoad.svg";
import DrainageSystem from "../../assets/DrainageSystem.svg";
import Spaces from "../../assets/Parks&OpenSpaces.svg";
import CompoundWall from "../../assets/CompoundWall.svg";
import Electricity from "../../assets/Electricity.svg";
import OverheadTank from "../../assets/OverheadTank.svg";
import BankLoanFacilities from "../../assets/BankLoanFacilities.svg";

// import ourProjectVideo from "../../assets/video.svg";
import skyline from "../../assets/skyline.mp4";


const InfrastructureFacilities = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out" });
  }, []);

  const cardData = [
    { title: "Gated Community Project", imageUrl: GatedCommunityProject },
    { title: "100% Vastu", imageUrl: Vastu },
    { title: "Water Tap Connection", imageUrl: WaterTapConnection },
    { title: "40 Feet CCRoad", imageUrl: FeetCCRoad },
    { title: "Drainage System", imageUrl: DrainageSystem },
    {
      title: (
        <>
          Parks & Open <br /> Spaces
        </>
      ),
      imageUrl: Spaces,
    },
    { title: "Compound Wall", imageUrl: CompoundWall },
    { title: "Electricity", imageUrl: Electricity },
    { title: "Overhead Tank", imageUrl: OverheadTank },
    { title: "Bank Loan Facilities", imageUrl: BankLoanFacilities },
  ];

  return (
    <div className="container-fluid py-5 InfrastructureFacilities-container bg-white">
      <div className="container">
        <div>
          <p className="InfrastructureFacilities">Infrastructure Facilities</p>
        </div>
        <div className="row custom-row">
          {cardData.map((card, index) => (
            <div
              key={index}
              className="col custom-col mb-4 d-flex justify-content-center"
              // data-aos={index < 5 ? "fade-down" : "fade-up"}
            >
              <div className="card custom-card">
                <img
                  src={card.imageUrl}
                  className="card-img-top mt-5 image-fluid"
                  alt={card.title}
                  style={{ width: "20%", height: "auto" }}
                />
                <div className="card-body text-center">
                  <h5 className="infrastructure-title">{card.title}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div
          className="mt-4 py-2"
          // data-aos="zoom-in"
        >
          {/* <img
            src={ourProjectVideo}
            alt="ourProjectVideo"
            className="img-fluid ourProjectVideo"
          /> */}
           <video
            src={skyline}
            alt="ourProjectVideo"
            className="img-fluid ourProjectVideo"
            controls
            autoPlay
            loop
            muted
          />
        </div>
      </div>
    </div>
  );
};

export default InfrastructureFacilities;
